import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import site from '../../data/site';
import styles from './StickyRail.module.css';

const ICONS = { github: faGithub, linkedin: faLinkedin, email: faEnvelope };

/**
 * Left column of the home page. Sticks to the viewport on >=1024px while the
 * timeline scrolls beside it; below that it unsticks into a normal hero block.
 */
export default function StickyRail() {
  const [loaded, setLoaded] = useState(false);

  return (
    <aside className={styles.rail}>
      <div className={styles.inner}>
        <figure className={styles.frame}>
          <img
            className={styles.photo}
            src={site.portrait}
            alt={site.portraitAlt}
            width={1280}
            height={1920}
            data-loaded={loaded}
            onLoad={() => setLoaded(true)}
            fetchpriority="high"
            decoding="async"
          />
          <span className={styles.duotone} aria-hidden="true" />
          <span className={styles.scrim} aria-hidden="true" />

          {/* Corner registration marks: the "instrument" detail */}
          <span className={`${styles.tick} ${styles.tickTL}`} aria-hidden="true" />
          <span className={`${styles.tick} ${styles.tickBR}`} aria-hidden="true" />

          <figcaption className={styles.overlay}>
            <p className={styles.status}>
              <span className={styles.dot} aria-hidden="true" />
              Open to New Grad roles
            </p>
            <h1 className={styles.name}>{site.name}</h1>
            <p className={styles.role}>{site.role}</p>
          </figcaption>
        </figure>

        <div className={styles.meta}>
          <p className={styles.education}>{site.education}</p>

          {site.bio.map((para) => (
            <p key={para.slice(0, 32)} className={styles.bio}>{para}</p>
          ))}

          <div className={styles.actions}>
            <ul className={styles.socials}>
              {site.socials.map((s) => (
                <li key={s.id}>
                  <a
                    href={s.href}
                    className={styles.social}
                    aria-label={s.label}
                    target={s.id === 'email' ? undefined : '_blank'}
                    rel={s.id === 'email' ? undefined : 'noreferrer'}
                  >
                    <FontAwesomeIcon icon={ICONS[s.id]} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </aside>
  );
}
